import {
  format,
  getHours,
  getMinutes,
  roundToNearestMinutes,
  set,
} from "date-fns";
import { utcToZonedTime, zonedTimeToUtc } from "date-fns-tz";

export const SERVER_DATE_WITH_TIME_FORMAT = "yyyy/MM/dd HH:mm";
export const SERVER_DATE_FORMAT = "yyyy-MM-dd";

export const convertDateToTimezone = (
  date: Date | string,
  timezone: string,
) => {
  return utcToZonedTime(date, timezone);
};

export const formatDateTimeToUTC = (date: Date): string => {
  return new Date(format(date, SERVER_DATE_WITH_TIME_FORMAT)).toISOString();
};

export const getDayOfWeek = (date: Date) => format(date, "EEEE");

export const getMonthWithDay = (date: Date) => format(date, "MMMM d");

export const getIntervalText = (interval: Date[]) =>
  `${getMonthWithDay(interval[0])} - ${getMonthWithDay(
    interval[interval.length - 1],
  )}`;

export const convertZonedDateToUTC = (date: Date, timezone: string) => {
  return zonedTimeToUtc(date, timezone);
};

export const ignoreTimezone = (date: string = "") => {
  return date.slice(0, -1);
};

export const roundTime = (date: Date, minutesStep: number) =>
  minutesStep <= 30
    ? roundToNearestMinutes(date, {
        nearestTo: minutesStep,
      })
    : set(date, {
        hours: getHours(date) + Math.round(getMinutes(date) / 60),
        minutes: 0,
        seconds: 0,
        milliseconds: 0,
      });

export const formatDate = isoString => {
  if (!isoString) return "";
  const date = new Date(isoString);
  if (isNaN(date.getTime())) return isoString;
  const month = ("0" + (date.getMonth() + 1)).slice(-2);
  const day = ("0" + date.getDate()).slice(-2);
  const year = date.getFullYear();
  return `${month}/${day}/${year}`;
};
